import { render } from "./QueOption3.vue?vue&type=template&id=3dfa8aaf"
import script from "./QueOption3.vue?vue&type=script&lang=js"
export * from "./QueOption3.vue?vue&type=script&lang=js"

import "./QueOption3.vue?vue&type=style&index=0&id=3dfa8aaf&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__